/**
 * Single source of truth for API paths. Nothing outside this file should
 * hardcode an "/api/..." string — import from here instead.
 */
export const API_VERSION = 'v1';

export const API_BASE_PATH = `/api/${API_VERSION}`;

export const API_ENDPOINTS = {
  health: `${API_BASE_PATH}/health`,
  authMe: `${API_BASE_PATH}/auth/me`,
  adminDashboardOverview: `${API_BASE_PATH}/admin/dashboard/overview`,
  // Base paths only -- every admin catalog/inventory/media route below
  // has id-scoped and/or nested sub-paths the caller builds with a
  // template literal off this base, rather than this file trying to
  // enumerate every dynamic-segment combination.
  adminProducts: `${API_BASE_PATH}/admin/products`,
  adminVariants: `${API_BASE_PATH}/admin/variants`,
  adminCategories: `${API_BASE_PATH}/admin/categories`,
  adminBrands: `${API_BASE_PATH}/admin/brands`,
  adminInventory: `${API_BASE_PATH}/admin/inventory`,
  adminWarehouses: `${API_BASE_PATH}/admin/warehouses`,
  adminMedia: `${API_BASE_PATH}/admin/media`,
  adminTaxRates: `${API_BASE_PATH}/admin/tax-rates`,
  // Admin Dashboard Milestone 3 (orders/payments/refunds/customers):
  adminOrders: `${API_BASE_PATH}/admin/orders`,
  adminPayments: `${API_BASE_PATH}/admin/payments`,
  adminRefunds: `${API_BASE_PATH}/admin/refunds`,
  adminCustomers: `${API_BASE_PATH}/admin/customers`,
  // Admin Dashboard Milestone 4:
  adminCoupons: `${API_BASE_PATH}/admin/coupons`,
  adminBanners: `${API_BASE_PATH}/admin/banners`,
  adminRewards: `${API_BASE_PATH}/admin/rewards`,
  adminNotifications: `${API_BASE_PATH}/admin/notifications`,
  adminNotificationDeliveries: `${API_BASE_PATH}/admin/notification-deliveries`,
  adminSettings: `${API_BASE_PATH}/admin/settings`,
  adminFeatureFlags: `${API_BASE_PATH}/admin/feature-flags`,
  adminIntegrations: `${API_BASE_PATH}/admin/integrations`,
  adminCurrencies: `${API_BASE_PATH}/admin/currencies`,
  adminDelivery: `${API_BASE_PATH}/admin/delivery`,
  adminAuditLogs: `${API_BASE_PATH}/admin/audit-logs`,
  adminReports: `${API_BASE_PATH}/admin/reports`,
  adminSystem: `${API_BASE_PATH}/admin/system`,
  adminRbac: `${API_BASE_PATH}/admin/rbac`,
  // Customer Storefront milestone -- base paths only, same convention as
  // every admin base path above (id-scoped/nested sub-paths are built
  // with a template literal off these at the call site).
  catalogCategories: `${API_BASE_PATH}/catalog/categories`,
  catalogBrands: `${API_BASE_PATH}/catalog/brands`,
  catalogProducts: `${API_BASE_PATH}/catalog/products`,
  banners: `${API_BASE_PATH}/banners`,
  cart: `${API_BASE_PATH}/cart`,
  wishlist: `${API_BASE_PATH}/wishlist`,
  addresses: `${API_BASE_PATH}/addresses`,
  delivery: `${API_BASE_PATH}/delivery`,
  coupons: `${API_BASE_PATH}/coupons`,
  checkout: `${API_BASE_PATH}/checkout`,
  orders: `${API_BASE_PATH}/orders`,
  payments: `${API_BASE_PATH}/payments`,
  rewards: `${API_BASE_PATH}/rewards`,
  notifications: `${API_BASE_PATH}/notifications`,
  // Marketing "Contact us" page -- public, unauthenticated.
  contact: `${API_BASE_PATH}/contact`,
} as const;

export type ApiEndpointKey = keyof typeof API_ENDPOINTS;
